import { createContext } from 'react';

const QuestionContext = createContext();

export default QuestionContext;
